// Iter 46: totale ore per dipendente di un singolo rapportino.
// Usato nella pagina "Da vidimare" e (live) nel form di compilazione.
import { UsersRound } from "lucide-react";

export function computeEmployeeTotals(righe) {
  const map = new Map();
  for (const r of righe || []) {
    const nome = (r?.employee_nome || "").trim();
    const ore = Number(r?.ore_tot) || 0;
    if (!nome && ore === 0) continue;
    const key = nome.toLowerCase() || "—";
    const cur = map.get(key) || { nome: nome || "Senza nome", ore: 0 };
    cur.ore += ore;
    map.set(key, cur);
  }
  return [...map.values()].sort(
    (a, b) => b.ore - a.ore || a.nome.localeCompare(b.nome)
  );
}

const fmtOre = (n) => {
  const v = Math.round(n * 100) / 100;
  return Number.isInteger(v) ? String(v) : v.toFixed(2).replace(/0$/, "");
};

export const EmployeeTotals = ({ righe, testId = "employee-totals", compact = false }) => {
  const totals = computeEmployeeTotals(righe);
  if (totals.length === 0) return null;
  const totale = totals.reduce((s, t) => s + t.ore, 0);
  return (
    <div data-testid={testId} className={compact ? "mt-2" : "mt-3"}>
      <div className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wide text-slate-500 mb-1.5">
        <UsersRound className="h-3.5 w-3.5" />
        Totale ore per dipendente
        <span className="normal-case font-normal text-slate-400">
          · {fmtOre(totale)}h complessive
        </span>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {totals.map((t) => (
          <span
            key={t.nome}
            data-testid={`${testId}-chip`}
            className="inline-flex items-center gap-1.5 rounded-full border border-slate-300 bg-white px-2.5 py-1 text-xs"
          >
            <span className="font-medium text-slate-800">{t.nome}</span>
            <span className="font-mono font-black text-[#0044FF]">
              {fmtOre(t.ore)}h
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};
